import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import './styles/TransferInventoryPage.css';
import { useNavigate, useParams } from 'react-router-dom'; 
import { generatePaymentReceiptPDF } from './util/paymentReceipt';

const StudentSavingFormPage = () => {
    const { studentId } = useParams();
    const [student, setStudent] = useState('');
    const [amount, setAmount] = useState(0);
    const [paymentDate, setPaymentDate] = useState('');
    const [description, setDescription] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/profile/${studentId}`);
                setStudent(response.data.data.student || null);
            } catch (error) {
                console.error("Failed to fetch student details", error);
            }
        };
        fetchStudentDetails();
    }, [studentId]);
    

    if (!student) return <p>Loading student details...</p>;

    const simulateProgress = (onComplete) => {
        setProgress(0);
        let percent = 0;
        const interval = setInterval(() => {
            percent += Math.random() * 10;
            if (percent >= 100) {
                clearInterval(interval);
                setProgress(100);
                if (typeof onComplete === 'function') {
                    setTimeout(() => {
                        onComplete(); // panggil setelah 100ms supaya UI sempat render 100%
                    }, 100);
                }
            } else {
                setProgress(Math.floor(percent));
            }
        }, 100);
    };

    const handleSubmit = async () => {

        if (amount == 0) {
            alert('Please fill payment amount!');
            return;
        }

        if (paymentDate === "") {
            alert('Please fill payment date!');
            return;
        }

        
        if (description === "") {
            alert('Please fill the description!');
            return;
        }

        
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
        
        const paymentData = {
            paymentMethod: paymentMethod,
        };
    
        const paymentDetails = [
            {
              item: `${description} ${student.student_name}`,
              amount: amount,
            }
        ];
    
        // Mempersiapkan data untuk dikirim
        const savingsData = {
            data: {
                savingsData: {
                    student_id: student.student_id, 
                    payment_amount: amount,
                    payment_date: paymentDate,
                    description: description,
                },
            },
        };
        setIsLoading(true);
        try {
            const response = await api.post('/saving/save', savingsData); 
            const successMessage = response.data.message;
            simulateProgress(() => {
                setIsLoading(false);
                generatePaymentReceiptPDF(student, paymentData, paymentDetails, paymentDate, 'GRADUATION');
                alert(successMessage);
                navigate(`/student/detail/${student.student_id}`)
            });
            
        } catch (error) {
            console.error('Error submitting data:', error);
            console.error('Error adding/updating student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        }
    };

    const handlePriceChange = (e) => {
        const value = e.target.value.replace(/\./g, ''); // Hapus titik
        if (value === '') {
            setAmount(0);
        } else {
            setAmount(parseFloat(value)); // Simpan sebagai angka
        }
    };

    
    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Student Savings Form</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Student Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.student_name : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Code</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.student_code : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Branch</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.Branch.branch_name : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Amount</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"     
                                            value={formatCurrency(amount)}  
                                            onChange={handlePriceChange} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Date</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="date"
                                            name="paymentDate"
                                            value={paymentDate} 
                                            onChange={e => setPaymentDate(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td>
                                        <label>Payment Method</label>
                                    </td>
                                    <td>
                                        <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} >
                                            <option key="" value="">Choose Payment Method</option>
                                            <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                            <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Description</label>
                                    </td>
                                    <td>
                                        <textarea 
                                            name="description"
                                            value={description} 
                                            onChange={e => setDescription(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
            {isLoading && (
            <div className="progress-overlay">
                <div className="progress-container">
                <div className="progress-bar" style={{ width: `${progress}%` }} />
                <div className="progress-text">{progress}%</div>
                </div>
            </div>
            )}
        </div>
    );
};

export default StudentSavingFormPage;
